module.exports = __webpack_public_path__ + "static/media/calendar_monthly.248c12aa.svg";